import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
   selector: 'app-forgot-password',
   templateUrl: './forgot-password.component.html',
   styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
   /**
    * Form group to get email values
    */
   forgotForm: FormGroup;
   /**
    * Component constructor
    * @param authService
    * @param fb
    * @param toastrService
    * @param spinnerService
    * @param router
    */
   constructor(
      private authService: AuthService,
      private fb: FormBuilder,
      private toastrService: ToastrService,
      private spinnerService: NgxSpinnerService,
      private router: Router,
      private translate: TranslateService
   ) { }
   /**
    * Method used to be called whenever the component is loaded and all the methods in it, will be triggered.
    */
   ngOnInit(): void {
      this.forgotForm = this.fb.group({
         email: ['', [Validators.required, Validators.email]],
      });
   }

   /**
    * Method used to get controls from formGroup
    * @constructor
    */
   get FormValues() {
      return this.forgotForm.controls;
   }

   /**
    * Method used to call forget password method service
    */
   submit() {
      this.spinnerService.show();
      this.authService
         .forgotPassword(this.forgotForm.value.email)
         .pipe(first())
         .subscribe(
            (data) => {
               this.spinnerService.hide();
               this.showToasterSuccess(this.translate.instant('new_entries.please_check_your_email'));
               this.router.navigateByUrl('/login');
            },
            (error) => {
               console.log('Error:', error);
               this.spinnerService.hide();
            }
         );
   }

   /**
    * Toaster used to show a success message toaster
    * @param message
    */
   showToasterSuccess(message) {
      this.toastrService.success(message);
   }

   /**
    * Toaster used to show a success message toaster
    * @param message
    */
   showToasterError(message) {
      this.toastrService.error(message);
   }

   /**
    * Toaster used to show a warning message toaster
    * @param message
    */
   showToasterWarning(message) {
      this.toastrService.warning(message);
   }
}
